export const LOCAL_STORAGE_ACCESS_TOKEN = 'accessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken'
export const LOCAL_STORAGE_ADMIN_TOKEN = 'adminAccessToken'
export const LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN = 'airbnbAccessToken'
export const LOCAL_STORAGE_AIRBNB_REFRESH_TOKEN = 'airbnbRefreshToken'
